import ChatBubbleOutlineIcon from '@mui/icons-material/ChatBubbleOutline';
import React from 'react'
import { useState, useEffect } from 'react';
import HomeIcon from '@mui/icons-material/Home';
import EditIcon from '@mui/icons-material/Edit';
import FlightTakeoffIcon from '@mui/icons-material/FlightTakeoff';
import Person4Icon from '@mui/icons-material/Person4';
import { Row, Col, Form, Button } from 'react-bootstrap';
import { FaCheckCircle, FaTimesCircle } from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import Footer from './Common_Components/Footer';

const QuizResult = () => {
  const [activePage, setActivePage] = useState("Learning");
  const navigate = useNavigate();
  const [selectedOption, setSelectedOption] = useState(null);

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
  };
  const [selectedLanguage, setSelectedLanguage] = useState('');
  const SelectLanguageLocal = localStorage.getItem("selectedLanguage");

  console.log(SelectLanguageLocal, "SelectLanguageLocal")
  useEffect(() => {
    const loadLanguage = async () => {
      try {
        const storedLanguage = localStorage.getItem("selectedLanguage");
        console.log("storedLanguage",storedLanguage);
        if (storedLanguage) {
          setSelectedLanguage(storedLanguage);
        }
      } catch (error) {
        console.error("Error loading language:", error);
      }
    };

    loadLanguage();
  }, []);
  return (
    <div className='Quiz_Result_container d-flex flex-column' style={{ minHeight: "100vh" }}>

      <div className='header_inner'>
        <div className='container'>
          <div className='row'>
            <div className='col-md-12'>
              <ArrowBackIosIcon onClick={() => navigate('/StartQuiz')} className='icon_1' />

              <h2>Quiz Result</h2>
              <ChatBubbleOutlineIcon onClick={() => navigate('/chat-with-staff')} className="logo_1" style={{ cursor: 'pointer', color: '#ffc0cb' }} />
            </div>


          </div>
        </div>
      </div>
      <div className="container  " style={{ marginTop: "100px", backgroundColor: "white", borderRadius: "15px" }} >
        <div className="row g-2">
          <div className="col-md-5 mb-1 " style={{ backgroundColor: "light gray", borderRadius: "15px", boxShadow: "2px 4px 10px rgba(0, 0, 0, 0.4)" }}>
            <div className="container my-4">
              <h3 style={{ textAlign: "left" }}>Question:</h3>
              <Form>
                <Row className="my-3">
                  <Col>
                    <Form.Check type="radio" name="options" value="option4" style={{ textAlign: "left" }}>
                      <Form.Check.Input style={{ marginRight: "10px" }} />
                      <Form.Check.Label>
                        Option sfdsnfsdjsdjfnsdj4
                        <FaTimesCircle style={{ color: "red", fontSize: "20px", marginLeft: "10px" }} />
                        <FaCheckCircle style={{ color: "green", fontSize: "20px", marginLeft: "10px" }} />
                      </Form.Check.Label>
                    </Form.Check>
                  </Col>
                </Row>
                <Row className="my-3">
                  <Col>
                    <Form.Check type="radio" name="options" value="option4" style={{ textAlign: "left" }}>
                      <Form.Check.Input style={{ marginRight: "10px" }} />
                      <Form.Check.Label>
                        Option sfdsnfsdjsdjfnsdj4
                        <FaTimesCircle style={{ color: "red", fontSize: "20px", marginLeft: "10px" }} /> {/* Wrong sign */}
                        <FaCheckCircle style={{ color: "green", fontSize: "20px" }} /> {/* Right sign (checkmark) */}
                      </Form.Check.Label>
                    </Form.Check>
                  </Col>
                </Row>
                <Row className="my-3">
                  <Col>
                    <Form.Check type="radio" name="options" value="option4" style={{ textAlign: "left" }}>
                      <Form.Check.Input style={{ marginRight: "10px" }} />
                      <Form.Check.Label>
                        Option sfdsnfsdjsdjfnsdj4
                        <FaTimesCircle style={{ color: "red", fontSize: "20px", marginLeft: "10px" }} /> {/* Wrong sign */}
                        <FaCheckCircle style={{ color: "green", fontSize: "20px" }} /> {/* Right sign (checkmark) */}
                      </Form.Check.Label>
                    </Form.Check>
                  </Col>
                </Row>
                <Row className="my-3">
                  <Col>
                    <Form.Check type="radio" name="options" value="option4" style={{ textAlign: "left" }}>
                      <Form.Check.Input style={{ marginRight: "10px" }} />
                      <Form.Check.Label>
                        Option sfdsnfsdjsdjfnsdj4
                        <FaTimesCircle style={{ color: "red", fontSize: "20px", marginLeft: "10px" }} /> {/* Wrong sign */}
                        <FaCheckCircle style={{ color: "green", fontSize: "20px" }} /> {/* Right sign (checkmark) */}
                      </Form.Check.Label>
                    </Form.Check>
                  </Col>
                </Row>
              </Form>
            </div>

          </div>

          <div className="col-md-1"></div>
          <div className="col-md-6 mb-1 " style={{ backgroundColor: "light gray", borderRadius: "15px", boxShadow: "2px 4px 10px rgba(0, 0, 0, 0.4)" }} >
            <div className="container my-4">
              <h3 style={{ textAlign: "left" }} >Exaplanation:</h3>
              <ul className="list-group" style={{ border: "none", padding: "0" }} >
                <li className="list-group-item" style={{ border: "none", backgroundColor: "transparent" }}>
                  <h3 className="h5" style={{ textAlign: "left" }} >Option 1</h3>
                  <p style={{ textAlign: "left" }}  >
                    Explanation for Option 1, detailing the key points and benefits.
                  </p>
                </li>
                <li className="list-group-item" style={{ border: "none", backgroundColor: "transparent" }}>
                  <h3 className="h5" style={{ textAlign: "left" }} >Option 1</h3>
                  <p style={{ textAlign: "left" }}  >
                    Explanation for Option 1, detailing the key points and benefits.
                  </p>
                </li>
                <li className="list-group-item" style={{ border: "none", backgroundColor: "transparent" }}>
                  <h3 className="h5" style={{ textAlign: "left" }} >Option 1</h3>
                  <p style={{ textAlign: "left" }}  >
                    Explanation for Option 1, detailing the key points and benefits.
                  </p>
                </li>
                <li className="list-group-item" style={{ border: "none", backgroundColor: "transparent" }}>
                  <h3 className="h5" style={{ textAlign: "left" }} >Option 1</h3>
                  <p style={{ textAlign: "left" }}  >
                    Explanation for Option 1, detailing the key points and benefits.
                  </p>
                </li>
              </ul>
            </div>

          </div>
          <div className="d-flex justify-content-end aling">
            <Link to={"/StartQuiz"} >
              <Button style={{ marginTop: "20px", width: "150px", marginBottom: "10px", backgroundColor: "black" }}>Next Day</Button>
            </Link>
          </div>

        </div>
      </div>

            <Footer />

    </div>
  )
}

export default QuizResult